namespace Matrix.Dashboards {
    export interface WidgetCatalogRow {
        WidgetCode?: string;
        Name?: string;
        WidgetType?: string;
        Permission?: string;
        Properties?: WidgetCatalogData;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace WidgetCatalogRow {
        export const idProperty = 'WidgetCode';
        export const nameProperty = 'WidgetCode';
        export const localTextPrefix = 'Dashboards.WidgetCatalog';
        export const deletePermission = 'Administration:Dashboards';
        export const insertPermission = 'Administration:Dashboards';
        export const readPermission = 'Read:Dashboards';
        export const updatePermission = 'Administration:Dashboards';

        export declare const enum Fields {
            WidgetCode = "WidgetCode",
            Name = "Name",
            WidgetType = "WidgetType",
            Permission = "Permission",
            Properties = "Properties",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
